﻿export class Survey {
    surveyId: number;
    code: string;
    title: string;
    validFrom: Date;
    validTo: string;
    surveyTypeId: number;
    surveyCategoryId: number;
    surveyParticipantTypeId: number;
    surveyStatusId: number;
    dateCreated: Date;
    languageID: number;
    questionNumber: number;
    surveyCategory: string;
    surveyStatus: string;
    surveyUniqueIdentifier: string;
    lastAnsweredQuestion: number;
    surveyParticipantId: number;
    smsverificationRequired: boolean;
    completedSurvey: boolean;
    sexId: number;
    demographicRequired: boolean;

}